/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Action_Edit_Designation_DescriptionInputs */

const fr_vehicle_action_edit_designation_description = /** @type {(inputs: Vehicle_Action_Edit_Designation_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merci d'être complet dans la dénomination du véhicule.`)
};

const en_vehicle_action_edit_designation_description = /** @type {(inputs: Vehicle_Action_Edit_Designation_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please provide a complete vehicle designation.`)
};

/**
* | output |
* | --- |
* | "Please provide a complete vehicle designation." |
*
* @param {Vehicle_Action_Edit_Designation_DescriptionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_action_edit_designation_description = /** @type {((inputs?: Vehicle_Action_Edit_Designation_DescriptionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Action_Edit_Designation_DescriptionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_action_edit_designation_description(inputs)
	return en_vehicle_action_edit_designation_description(inputs)
});